import { Navigate, useLocation, useParams } from 'react-router-dom';
import { resolveTemplate } from 'utils';
import * as noteConstants from 'modules/project/StopeNotePage/constants';

// The per-pour note route is retired: a pour's note now lives on the unified stope-scoped note page.
// This forwards old `/pours/:pourId` links (and bookmarks) there, asking the page to expand the
// clicked pour, while preserving any route-point state the caller passed.
const PourDetailsRedirect = () => {
  const { projectId, stopeId, pourId } = useParams<{ projectId: string; stopeId: string; pourId: string }>();
  const { state } = useLocation();

  const to = resolveTemplate(noteConstants.ROUTE_PATH, {
    [noteConstants.ROUTE_PARAM_IDENTIFIER]: projectId ?? '',
    [noteConstants.STOPE_PARAM_IDENTIFIER]: stopeId ?? '',
  });

  const forwardedState = { ...(state && typeof state === 'object' ? state : {}), expandPourId: pourId };

  return <Navigate to={to} replace state={forwardedState} />;
};

export default PourDetailsRedirect;
